// extracted by mini-css-extract-plugin
export default {"back-button":"back-button_back-button__9fP2K"};